import React from 'react';

/**
 * DataOps Events Help Content
 */
const EventsHelp: React.FC = () => {
  return (
    <>
      <div>
        <h3 className="text-base font-semibold text-gray-900 dark:text-white mb-2">
          Data Events
        </h3>
        <p className="text-sm text-gray-600 dark:text-gray-400 leading-relaxed">
          Stay informed about all activities in your data platform. Events capture data arrivals, schema changes, quality alerts, and other important notifications to help you maintain data reliability.
        </p>
      </div>

      <div>
        <h3 className="text-base font-semibold text-gray-900 dark:text-white mb-2">
          Event Types
        </h3>
        <div className="space-y-2 text-sm text-gray-600 dark:text-gray-400">
          <p>&#8226; <span className="font-medium">Data Events</span>: Track data arrivals, updates, and deletions</p>
          <p>&#8226; <span className="font-medium">Schema Changes</span>: Monitor column additions, removals, or type changes</p>
          <p>&#8226; <span className="font-medium">Pipeline Events</span>: See pipeline starts, completions, and failures</p>
          <p>&#8226; <span className="font-medium">Quality Alerts</span>: Receive notifications about data quality issues</p>
          <p>&#8226; <span className="font-medium">Access Events</span>: Track who accessed or modified data</p>
        </div>
      </div>

      <div>
        <h3 className="text-base font-semibold text-gray-900 dark:text-white mb-2">
          Event Feed
        </h3>
        <p className="text-sm text-gray-600 dark:text-gray-400 leading-relaxed mb-3">
          Browse and filter the event timeline:
        </p>
        <div className="space-y-2 text-sm text-gray-600 dark:text-gray-400">
          <p>&#8226; <span className="font-medium">Chronological view</span>: Events sorted by occurrence time</p>
          <p>&#8226; <span className="font-medium">Type filters</span>: Focus on specific event categories</p>
          <p>&#8226; <span className="font-medium">Asset filters</span>: View events for specific tables or pipelines</p>
          <p>&#8226; <span className="font-medium">Severity levels</span>: Filter by info, warning, or critical</p>
        </div>
      </div>

      <div>
        <h3 className="text-base font-semibold text-gray-900 dark:text-white mb-2">
          Event Details
        </h3>
        <p className="text-sm text-gray-600 dark:text-gray-400 leading-relaxed mb-3">
          Click any event to see more information:
        </p>
        <div className="space-y-2 text-sm text-gray-600 dark:text-gray-400">
          <p>&#8226; <span className="font-medium">Timestamp</span>: Exact time of occurrence</p>
          <p>&#8226; <span className="font-medium">Affected assets</span>: Tables, columns, or pipelines involved</p>
          <p>&#8226; <span className="font-medium">Change details</span>: Specific before/after values when applicable</p>
          <p>&#8226; <span className="font-medium">Source</span>: System or user that triggered the event</p>
        </div>
      </div>

      <div>
        <h3 className="text-base font-semibold text-gray-900 dark:text-white mb-2">
          Notifications
        </h3>
        <div className="space-y-2 text-sm text-gray-600 dark:text-gray-400">
          <p>&#8226; <span className="font-medium">Alert rules</span>: Configure notifications for important events</p>
          <p>&#8226; <span className="font-medium">Channels</span>: Receive alerts via email, Slack, or webhooks</p>
          <p>&#8226; <span className="font-medium">Subscriptions</span>: Follow specific assets or event types</p>
        </div>
      </div>

    </>
  );
};

export default EventsHelp;
